export const HIGHLIGHTING_MODES = {
  SINGLE_ATOM: 'SINGLE_ATOM',
  ALL_SUBSTRATE_ATOMS: 'ALL_SUBSTRATE_ATOMS',
  SURVIVING_SUBSTRATE_ATOMS: 'SURVIVING_SUBSTRATE_ATOMS',
  COMPOUND_NATIVE: 'COMPOUND_NATIVE',
};
